import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa",
    values: {
      checkboxOn: "far fa-check-circle",
      checkboxOff: "far fa-circle",
      checkboxIndeterminate: "far fa-circle",
      sort: "fas fa-arrow-up"
    }
  },
  theme: {
    themes: {
      light: {
        primary: "#ffffff",
        secondary: "#C5C5C5",
        tertiary: "#7f7f7f",
        text: {
          green: "#94C83B",
          blue: "#00b0f0",
          gray: "#7f7f7f"
        }
      },
      dark: {
        primary: "#000",
        secondary: "#2b292a",
        tertiary: "#131313",
        text: {
          green: "#94C83B",
          blue: "#00b0f0",
          gray: "#7f7f7f"
        }
      },
    },
    
    dark: true,
    light: false
  }
});
